import { fetchGroups, selectCurrentGroup, resetCurrentGroup } from '../../actions/settings_actions';
import { connect } from 'react-redux';

import GroupManagement from '../../components/Settings/groupManagement';

function mapStateToProps(state) {
    return {
        groups: state.settings.groups,
        groupsError: state.settings.groupsError,
        groupsIsLoading: state.settings.groupsIsLoading,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { fetchGroups, selectCurrentGroup, resetCurrentGroup })(GroupManagement);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/groupManagement.jsx